import {
    NSF_STORAGE_CURIOSITY_FLOW,
    RedTariff,
    SAILS_VVL_STORAGE,
    SalesChannel,
    SALESCHANNEL_CONSUMER,
    SALESCHANNEL_YOUNG,
    YoungTariff,
} from '@vfde-sails/constants';
import {
    getSessionStorageItemJson,
    getSubscriptionFromNsf,
    getSubscriptionIdFromSails,
    NsfStorage,
    SailsVvlStorage,
} from '@vfde-sails/storage';
import {
    isRedTariff,
    isYoungTariff,
} from '@vfde-sails/utils';

const getActiveSubscriptionId = (
    salesChannel: Extract<SalesChannel, typeof SALESCHANNEL_CONSUMER | typeof SALESCHANNEL_YOUNG>,
): RedTariff | YoungTariff | null =>
    getActiveSubscriptionIdFromSailsStorage(salesChannel) ?? getActiveSubscriptionIdFromNsfStorage(salesChannel);

export default getActiveSubscriptionId;

const getActiveSubscriptionIdFromSailsStorage = (
    salesChannel: Extract<SalesChannel, typeof SALESCHANNEL_CONSUMER | typeof SALESCHANNEL_YOUNG>,
): RedTariff | YoungTariff | null => {
    const storage = getSessionStorageItemJson<SailsVvlStorage>(SAILS_VVL_STORAGE);

    if (!storage) {
        return null;
    }

    const subscriptionId = getSubscriptionIdFromSails(storage, salesChannel);

    if (!isRedTariff(subscriptionId) && !isYoungTariff(subscriptionId)) {
        return null;
    }

    return subscriptionId;
};

const getActiveSubscriptionIdFromNsfStorage = (
    salesChannel: Extract<SalesChannel, typeof SALESCHANNEL_CONSUMER | typeof SALESCHANNEL_YOUNG>,
): RedTariff | YoungTariff | null => {
    const storage = getSessionStorageItemJson<NsfStorage>(NSF_STORAGE_CURIOSITY_FLOW);

    if (!storage) {
        return null;
    }

    const subscriptionId = getSubscriptionFromNsf(storage)?.[salesChannel];

    if (!isRedTariff(subscriptionId) && !isYoungTariff(subscriptionId)) {
        return null;
    }

    return subscriptionId;
};
